"use strict";

import React from "react";
import ReactDOM from "react-dom";
import 'whatwg-fetch';
import Promise from 'promise-polyfill';
//import WithLoader from '../WithLoader.jsx';
import style from './PhiEvents.scss';
import Loader from "../Loader.jsx";


if (!window.Promise) {
	window.Promise = Promise;
}


//Deprecated Dec 12, 2019
//const API = 'https://www.eventbriteapi.com/v3/events/search/?sort_by=date&organizer.id=16496567258&include_all_series_instances=on&token=UVJPWHBIQL5SRPP2K2KN';


const API = '/EventBriteAPI/api/events';

//TESTER
//const API = '/EventBriteAPI/api/events?event_status=all&time_filter=all&order_by=start_desc';



class PhiEvent extends React.Component {
	constructor(props) {
		super(props);
	}


	formatDate(date) {
		var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
			"Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
		];

		var dayNames = ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"];

		var hours = date.getHours();
		var minutes = date.getMinutes();
		var ampm = hours >= 12 ? 'pm' : 'am';
		hours = hours % 12;
		hours = hours ? hours : 12; // the hour '0' should be '12'
		minutes = minutes < 10 ? '0' + minutes : minutes;
		var strTime = hours + ':' + minutes + ' ' + ampm;
		return dayNames[date.getDay()] + " " + monthNames[date.getMonth()] + " " + date.getDate() + ", " + date.getFullYear() + "  " + strTime;
	}

	render() {

		var datestart = new Date(this.props.datestart);

		var trimmedString = '';

		if (this.props.eventdesc) {
			var maxLength = 150;
			var ellipsis = '';

			ellipsis = (this.props.eventdesc.length > maxLength) ? "..." : "";

			trimmedString = this.props.eventdesc.substr(0, maxLength);

			trimmedString = trimmedString.substr(0,
				Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")));

			trimmedString += ellipsis;
		}


		return (
			<a className="raised card" href={this.props.url} target="_blank">
				<div className="image">
					<img src={this.props.logo} />
				</div>
				
				<div className="content">
					<div className="header" dangerouslySetInnerHTML={{ __html: this.props.eventname }} />
					<div className="meta">
						<span>{this.formatDate(datestart)}</span>
						
					</div>
					<div className="description" >{trimmedString}</div>
				</div>
				<div className="ui bottom attached large secondary button">
					<i className="fa fa-user-plus" style={{ fontSize: '1.5em' }}></i> Register
				</div>

			</a>
		);
		

	}
}


class PhiEvents extends React.Component {


	constructor(props) {

		super(props);


		this.state = {
			error: null,
			isLoaded: false,
			events: []
		};


	}

	componentDidMount() {

		function handleErrors(response) {
			if (!response.ok) {
				throw Error(response.statusText);
			}
			return response.json();
		}

			window.fetch(API)
				//.then(res => res.json())
				.then(handleErrors)
				.then(
					(result) => {
						this.setState({
							isLoaded: true,
							events: result.events
						});
					},
					(error) => {
						this.setState({
							isLoaded: true,
							error
						});
					}
				).catch(
					(error) => {
						this.setState({
							isLoaded: true,
							error
						});
					}
				)
			

	
	}

	render() {

		const { error, isLoaded, events } = this.state;

		var ReturnValue = null;

		if (error) {
			
			ReturnValue = <h3 style={{ textAlign: 'center' }}>Error:  {error.message}</h3>;
		} else if (!isLoaded) {
			ReturnValue = <div style={{position:'relative', minHeight:'300px'}}><Loader /></div>;
		} else {
			if (events.length > 0) {
				ReturnValue = <div className="ui link centered cards" >
					{
						events.map(item => (
							//(item.status === 'live' && new Date(item.start.local) >= new Date()) ?
							(true) ?
								<React.Fragment key={item.id}>
									<PhiEvent
										eventname={item.name.text}
										eventdesc={item.summary}
										datestart={item.start.local}
										onlineevent={item.online_event}
										status={item.status}
										url={item.url}
										logo={item.logo != null ? item.logo.original.url : null}
									/>
								</React.Fragment>
								:
								null
						)
						)
					}
				</div>;
			} else {
				ReturnValue = <h3 style={{textAlign:'center'}}>There are currently no available events.  Please check back later.</h3>
			}
		}



		
			return (
				<div className="section content-section phievents" >
					<div className="section__inner content-section__inner">
						<div className="content-section__header">
							<h2>Broker Events</h2>
						</div>

						{ReturnValue}

						</div>
				</div>




			);

		}



	}




//export default PhiEvents;

const App = <PhiEvents />
ReactDOM.render(
	App,
	document.getElementById('AppContainer')
);